import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedRadioGroup } from '../../../../Common/ui-components';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import './index.scss';

const ShowType = () => {
    const { t } = useTranslation();
    const context = useContext(GlobalContext);
    const { rsShowType, setRsShowType, setLocalParaRef } = context;

    const basicOptions = [
        { label: t('RS_SIMPLE'), value: 'Simple' },
        { label: t('RS_ADVANCED'), value: 'Advanced' }
    ];

    return (
        <AnimatedRadioGroup
            containerClassName="race-simulator-ShowType-container"
            className="race-simulator-ShowType"
            options={basicOptions}
            value={rsShowType}
            onChange={(v) => {
                setLocalParaRef.current({ rsShowType: v });
            }}
        />
    );
};
export default ShowType;
